<template>
  <div class="GameDirectory container">
    <Table
      :url="endpoint"
      :sort="sort.by"
      :order="sort.order"
    >
      <template
        v-slot:default="response"
      >
        <Row header>
          <Cell></Cell>
          <Cell sort="name"     v-model="sort" class="text-left">Game Name</Cell>
          <Cell sort="map"      v-model="sort">Map</Cell>
          <Cell sort="length"   v-model="sort">Length</Cell>
          <Cell sort="playedOn" v-model="sort">Uploaded</Cell>
        </Row>

        <Row
          v-for="replay in response"
          :to="{
            name: 'gameProfile',
            params: {
              id: replay.id
            }
          }"
        >
          <Cell>
            <v-popover
              trigger='hover'
              placement='left'
              popoverBaseClass="tooltip"
              style="display: inline-block"
            >
              <i
                class="fas ml10 mr10"
               :class="{
                  'invisible' : !replay.players.length,
                  'fa-user'   : replay.players.length < 6,
                  'fa-users'  : replay.players.length >= 6
               }"
              ></i>

              <template slot="popover">
                <ul class="condensed text-nowrap">
                  <li
                    v-for="player in replay.players"
                  >
                    <Block
                      :colour="player.colour"
                      :size="10"
                    ></Block> {{ battleTag (player.name) }}
                  </li>
                </ul>
              </template>
            </v-popover>

            <i
              class="fas fa-wave-square mr10 orange"
              v-tooltip="'Custom Data'"
              :class="{ 'invisible' : ! (replay.flags & CST.REPLAY_HAS_W3MMD) }"
            ></i>

            <i
              class="fas fa-trophy mr10 yellow"
              v-tooltip="'Rated Game'"
              :class="{ 'invisible' : ! (replay.flags & CST.REPLAY_RATED) }"
            ></i>

            <v-popover
              trigger="hover"
              placement="right"
              class="d-inline-block"
              popoverBaseClass="tooltip"
              popoverClass="text-nowrap"
              popoverInnerClass="pt-3 pb-3 mw-initial tooltip-inner popover-inner"
              v-if="'excerpts' in replay"
            >
              <i class="fas fa-comments mr10"></i>

              <template
                slot="popover"
                v-if="'excerpts' in replay"
              >
                <table>
                  <tbody
                    v-for="(excerpt, i) in replay.excerpts"
                    v-if="i < 3"
                  >
                    <tr
                      class="text-left"
                      v-for="(log, j) in excerpt"
                    >
                      <td
                        :class="{ 'pt-3' : i !== 0 && j === 0 }"
                        :style="`color: ${rgba ('--wc3-' + codeToColour (log.colour))}`"
                      >
                        {{ log.name }}
                      </td>

                      <td
                        :class="{ 'pt-3' : i !== 0 && j === 0 }"
                      >
                        <span class="ml-2">{{ log.message }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div
                  v-if="replay.excerpts.length > 3"
                  class="grey mt-3"
                >
                  {{ replay.excerpts.length - 3 }} more not shown.
                </div>
              </template>
            </v-popover>

            <i v-else class="fas fa-comments invisible mr10"></i>


            <v-popover
              trigger='hover'
              placement='top'
              popoverBaseClass="tooltip"
              style="display: inline-block"
              v-if="'isWinner' in replay && replay.isWinner !== null"
            >
              <i
                class="fas fa-flag"
                :class="{
                    'invisible' : ! ('isWinner' in replay) || replay.isWinner === null,
                    'green' : replay.isWinner,
                    'red' : !replay.isWinner
                 }"
              ></i>

              <template slot="popover">
                {{ replay.isWinner ? 'Winner' : 'Loser' }}
                <Delta
                  :x="replay.change"
                  :showNumber="true"
                >
                </Delta>
              </template>
            </v-popover>

          </Cell>
          <Cell class="text-left">{{ replay.name }}</Cell>
          <Cell>{{ replay.map }}</Cell>
          <Cell>{{ time (replay.length) }}</Cell>
          <Cell v-tooltip="fulldate (replay.playedOn)">{{ timeago (replay.playedOn) }}</Cell>
        </Row>
      </template>
    </Table>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Loader from '@/legacy/components/widgets/Loader';
  import Block from '@/legacy/components/widgets/Block';
  import Delta from '@/legacy/components/widgets/Delta';
  import { Table, Row, Cell } from '@/legacy/components/widgets/Table.js';
  import { time, timeago, httpBuildQuery, urlencode, fulldate } from '@/legacy/lib//util';
  import { battleTag, rgba, codeToColour } from '@/legacy/lib//template';
  import Key from '@/legacy/lib//model/Key';
  import CST from '@/legacy/lib//Constants';

  export default {
    components: {
      Loader,
      Table,
      Row,
      Cell,
      Block,
      Delta
    },

    methods: {
      time,
      timeago,
      battleTag,
      fulldate,
      rgba,
      codeToColour
    },

    props: {
      pk: {
        type: Object,
        default: () => new Key ()
      },

      for: {
        type: String,
      },
    },

    data () {
      return {
        sort: {
          by: 'playedOn',
          order: 'desc'
        },

        CST
      };
    },

    computed: {
      endpoint () {
        let obj = JSON.parse (JSON.stringify (this.pk));

        obj.for = urlencode (this.for);
        obj.chat = 1;

        return httpBuildQuery (
          '/replays',
          obj
        );
      }
    }
  }
</script>